import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewCustomerCountByRecipientRoutingModule } from './new-customer-count-by-recipient-routing.module';
import { NewCustomerCountByRecipientComponent } from './new-customer-count-by-recipient.component';
import { NewCustomerCountByRecipientFilterComponent } from './new-customer-count-by-recipient-filter/new-customer-count-by-recipient-filter.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { ReportModule } from '../report.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    NewCustomerCountByRecipientRoutingModule,
    ReportModule
  ],
  declarations: [NewCustomerCountByRecipientComponent, NewCustomerCountByRecipientFilterComponent],
  entryComponents:[NewCustomerCountByRecipientFilterComponent]
})
export class NewCustomerCountByRecipientModule { }
